
	export default {
		data () {
			return {
				loading: true,
				selectedModel: [],
				purgeDeletedModel: [],
				purgeSyncOption: [
					{
						label: 'items',
						key: 'Item'
					},
					{
						label: 'variations',
						key: 'Variation'
					},
					{
						label: 'tax',
						key: 'Tax'
					},
					{
						label: 'discount',
						key: 'Discount'
					},
					{
						label: 'category',
						key: 'Category'
					},
					{
						label: 'brands',
						key: 'item_brands'
					},
					{
						label: 'customers',
						key: 'merchant_customers'
					},
					{
						label: 'charges',
						key: 'merchant_charges'
					},
					{
						label: 'tables',
						key: 'merchant_floor_tables'
					}
				]
			}
		},
		computed: {
			appVersionNumber () {
				return this.$store.getters.appVersionNumber
			},
			deviceId () {
				return this.$store.state.deviceId
			},
			locationId () {
				return this.$store.state.locationId
			},
			merchant () {
				return this.$store.state.selectedMerchant || this.$store.state.merchant
			},
			settings () {
				return this.$store.state.settings
			},
			isPrimaryDevice () {
				return this.$store.state.device.is_primary
			},
			syncDetails: {
				get () {
					return this.$store.state.syncDetails
				},
				set (value) {
					this.$store.commit('setState', {
						key: 'syncDetails',
						value,
						save: true
					})
				}
			},
			selectableModels () {
				return this.models.filter(m => this.syncDetails[m] && this.syncDetails[m].type === 'down')
			},
			selectAllModels: {
				get () {
					return this.selectedModel.length === this.selectableModels.length
				},
				set (value) {
					this.selectedModel = value ? this.selectableModels.slice() : []
				}
			},
			purgeDeleteAllModels: {
				get () {
					return this.purgeDeletedModel.length === this.purgeSyncOption.length
				},
				set (value) {
					this.purgeDeletedModel = value ? this.purgeSyncOption.map(d => d.key) : []
				}
			},
			models () {
				return Object.keys(this.syncDetails).reduce((acc, key) => {
					if (['devices', 'floors', 'floor-tables'].includes(key)) {
						if (['restaurant', 'qsr'].includes(this.merchant.businessType)) {
							acc.push(key)
						}
					} else if (['employee-shifts', 'cash-drawer-shifts', 'order', 'cash-drawer-shift-event', 'order-refund', 'customer-credit'].includes(key)) {
						if (!this.settings.general.enable_token_number_system || this.isPrimaryDevice) {
							acc.push(key)
						}
					} else {
						acc.push(key)
					}

					return acc
				}, [])
			}
		},
		async beforeMount () {
			let syncDetails = {}

			if (this.appVersionNumber >= 4015) {
				syncDetails = await this.$bridge.getSyncDetails(this.merchant.id, this.locationId, this.deviceId)
				syncDetails = typeof syncDetails === 'string' ? JSON.parse(syncDetails) : syncDetails
			} else if (this.appVersionNumber >= 4010) {
				syncDetails = {
					'devices-total': await this.$bridge.getData(
						'Device', `merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId} AND location_id = ${this.locationId}`, -1, true
					),
					'floors-total': await this.$bridge.getData(
						'Floor', `merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId} AND location_id = ${this.locationId}`, -1, true
					),
					'floor-tables-total': await this.$bridge.getData(
						'Table', `merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId} AND location_id = ${this.locationId}`, -1, true
					),
					'employees-total': await this.$bridge.getData(
						'Employee', `merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId}`, -1, true
					),
					'merchant-customer-groups-total': await this.$bridge.getData(
						'CustomerGroup', `merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId}`, -1, true
					),
					'merchant-customers-total': await this.$bridge.getData(
						'Customer', `merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId}`, -1, true
					),
					'merchant-customers-synced': await this.$store.dispatch('bridgeCall', {
						methodName: 'getData',
						args: [
							'Customer',
							`merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId} AND customer_id != null`,
							-1,
							true
						]
					}),
					'categories-total': await this.$bridge.getData(
						'Category', `merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId}`, -1, true
					),
					'merchant-price-categories-total': await this.$bridge.getData(
						'PriceCategory', `merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId} AND type = 'base'`, -1, true
					),
					'taxes-total': await this.$bridge.getData(
						'Tax', `merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId}`, -1, true
					),
					'discounts-total': await this.$bridge.getData(
						'Discount', `merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId} AND location_id = ${this.locationId}`, -1, true
					),
					'merchant-charges-total': await this.$bridge.getData(
						'Charge', `merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId} AND location_id = ${this.locationId}`, -1, true
					),
					'items-total': await this.$bridge.getData(
						'Item', `merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId}`, -1, true
					),
					'item-variation-groups-total': await this.$bridge.getData(
						'ItemVariationGroup', `merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId} AND location_id = ${this.locationId}`, -1, true
					),
					'merchant-payment-methods-total': await this.$bridge.getData(
						'PaymentMethod', `merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId}`, -1, true
					),
					'employee-shifts-total': await this.$store.dispatch('bridgeCall', {
						methodName: 'getData',
						args: [
							'EmployeeShift',
							`merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId} AND location_id = ${this.locationId}`,
							-1,
							true
						]
					}),
					'employee-shifts-synced': await this.$store.dispatch('bridgeCall', {
						methodName: 'getData',
						args: [
							'EmployeeShift',
							`merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId} AND location_id = ${this.locationId} AND is_synced = true`,
							-1,
							true
						]
					}),
					'cash-drawer-shifts-total': await this.$store.dispatch('bridgeCall', {
						methodName: 'getData',
						args: [
							'CashDrawerShift',
							`merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId}`,
							-1,
							true
						]
					}),
					'cash-drawer-shifts-synced': await this.$store.dispatch('bridgeCall', {
						methodName: 'getData',
						args: [
							'CashDrawerShift',
							`merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId} AND is_synced = true`,
							-1,
							true
						]
					}),
					'order-total': await this.$store.dispatch('bridgeCall', {
						methodName: 'getData',
						args: [
							'Order',
							`merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId} AND location_id = ${this.locationId}`,
							-1,
							true
						]
					}),
					'order-synced': await this.$store.dispatch('bridgeCall', {
						methodName: 'getData',
						args: [
							'Order',
							`merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId} AND location_id = ${this.locationId} AND is_synced = true`,
							-1,
							true
						]
					}),
					'cash-drawer-shift-event-total': await this.$store.dispatch('bridgeCall', {
						methodName: 'getData',
						args: [
							'CashDrawerShiftEvent',
							`merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId}`,
							-1,
							true
						]
					}),
					'cash-drawer-shift-event-synced': await this.$store.dispatch('bridgeCall', {
						methodName: 'getData',
						args: [
							'CashDrawerShiftEvent',
							`merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId} AND is_synced = true`,
							-1,
							true
						]
					}),
					'order-refund-total': await this.$store.dispatch('bridgeCall', {
						methodName: 'getData',
						args: [
							'OrderRefund',
							`merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId}`,
							-1,
							true
						]
					}),
					'order-refund-synced': await this.$store.dispatch('bridgeCall', {
						methodName: 'getData',
						args: [
							'OrderRefund',
							`merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId} AND is_synced = true`,
							-1,
							true
						]
					}),
					'customer-credit-total': await this.$store.dispatch('bridgeCall', {
						methodName: 'getData',
						args: [
							'Credit',
							`merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId}`,
							-1,
							true
						]
					}),
					'customer-credit-synced': await this.$store.dispatch('bridgeCall', {
						methodName: 'getData',
						args: [
							'Credit',
							`merchant_id = ${this.merchant.id} AND device_id = ${this.deviceId} AND is_synced = true`,
							-1,
							true
						]
					})
				}
			} else {
				syncDetails = {
					devices: await this.$bridge.getSyncDetails(
						'Device', this.merchant.id, this.deviceId, 'is_synced', '=', 'true'
					),
					floors: await this.$bridge.getSyncDetails(
						'Floor', this.merchant.id, this.deviceId, 'is_synced', '=', 'true'
					),
					'floor-tables': await this.$bridge.getSyncDetails(
						'Table', this.merchant.id, this.deviceId, 'is_synced', '=', 'true'
					),
					'merchant-reservation': await this.$bridge.getSyncDetails(
						'Reservation', this.merchant.id, this.deviceId, 'is_synced', '=', 'true'
					),
					employees: await this.$bridge.getSyncDetails(
						'Employee', this.merchant.id, this.deviceId, 'is_synced', '=', 'true'
					),
					'merchant-customer-groups': await this.$bridge.getSyncDetails(
						'CustomerGroup', this.merchant.id, this.deviceId, 'is_synced', '=', 'true'
					),
					'merchant-customers': await this.$bridge.getSyncDetails(
						'Customer', this.merchant.id, this.deviceId, 'customer_id', '!=', 'null'
					),
					categories: await this.$bridge.getSyncDetails(
						'Category', this.merchant.id, this.deviceId, 'is_synced', '=', 'true'
					),
					'merchant-price-categories': await this.$bridge.getSyncDetails(
						'PriceCategory', this.merchant.id, this.deviceId, 'is_synced', '=', 'true'
					),
					taxes: await this.$bridge.getSyncDetails(
						'Tax', this.merchant.id, this.deviceId, 'is_synced', '=', 'true'
					),
					discounts: await this.$bridge.getSyncDetails(
						'Discount', this.merchant.id, this.deviceId, 'is_synced', '=', 'true'
					),
					'merchant-charges': await this.$bridge.getSyncDetails(
						'Charge', this.merchant.id, this.deviceId, 'is_synced', '=', 'true'
					),
					items: await this.$bridge.getSyncDetails(
						'Item', this.merchant.id, this.deviceId, 'is_synced', '=', 'true'
					),
					'item-variation-groups': await this.$bridge.getSyncDetails(
						'ItemVariationGroup', this.merchant.id, this.deviceId, 'is_synced', '=', 'true'
					),
					'merchant-payment-methods': await this.$bridge.getSyncDetails(
						'PaymentMethod', this.merchant.id, this.deviceId, 'is_synced', '=', 'true'
					),
					'employee-shifts': await this.$store.dispatch('bridgeCall', {
						methodName: 'getSyncDetails',
						args: ['EmployeeShift', this.merchant.id, this.deviceId, 'is_synced', '=', 'true']
					}),
					'cash-drawer-shifts': await this.$store.dispatch('bridgeCall', {
						methodName: 'getSyncDetails',
						args: ['CashDrawerShift', this.merchant.id, this.deviceId, 'is_synced', '=', 'true']
					}),
					order: await this.$store.dispatch('bridgeCall', {
						methodName: 'getSyncDetails',
						args: ['Order', this.merchant.id, this.deviceId, 'is_synced', '=', 'true']
					}),
					'cash-drawer-shift-event': await this.$store.dispatch('bridgeCall', {
						methodName: 'getSyncDetails',
						args: ['CashDrawerShiftEvent', this.merchant.id, this.deviceId, 'is_synced', '=', 'true']
					}),
					'order-refund': await this.$store.dispatch('bridgeCall', {
						methodName: 'getSyncDetails',
						args: ['OrderRefund', this.merchant.id, this.deviceId, 'is_synced', '=', 'true']
					}),
					'customer-credit': await this.$store.dispatch('bridgeCall', {
						methodName: 'getSyncDetails',
						args: ['Credit', this.merchant.id, this.deviceId, 'is_synced', '=', 'true']
					})
				}
			}

			Object.keys(syncDetails).forEach((sd) => {
				syncDetails[sd] = typeof syncDetails[sd] === 'string'
					? JSON.parse(syncDetails[sd])
					: syncDetails[sd]
			})

			this.syncDetails = this.models.reduce((acc, m) => {
				acc[m] = {
					...this.syncDetails[m],
					total: syncDetails[`${m}-total`]?.total || syncDetails[m]?.total,
					synced: syncDetails[`${m}-synced`]?.total || syncDetails[m]?.synced
				}

				return acc
			}, {})

			this.loading = false
		},
		mounted () {
			window.syncQueueRepaired = () => this.$emit('update:syncDetails')
		},
		methods: {
			onPurgeDeletedData (key) {
				if (key === 'purge_all') {
					this.purge()
				} else if (key === 'purge_option') {
					this.purgeDeletedModel = []
					this.$refs.purgeDeletedOptionModel.show()
				}
			},
			purgeDeleteSyncModel () {
				if (!this.purgeDeletedModel || !this.purgeDeletedModel.length) { return }

				this.purge()
				this.$refs.purgeDeletedOptionModel.hide()
			},
			onForceSyncSelect (key, $event) {
				if (key === 'sync_all') {
					this.forceSync(null, $event)
				} else if (key === 'sync_option') {
					this.selectedModel = []
					this.$refs.selectSyncModel.show()
				}
			},
			syncSelectedModel ($event) {
				if (!this.selectedModel || !this.selectedModel.length) { return }

				this.$refs.selectSyncModel.hide()
				this.forceSync(null, $event)
			},
			purge () {
				this.$swal({
					title: this.$t('areYouSure'),
					text: this.$t('deleteSyncText'),
					icon: 'info',
					buttons: [this.$t('no'), this.$t('yes')]
				}).then((response) => {
					if (response) {
						this.$store.dispatch('purge', this.purgeDeletedModel)
						this.purgeDeletedModel = []
					}
				})
			},
			repairSyncQueue ($event) {
				const el = $event.currentTarget

				this.$swal({
					title: this.$options.filters.capitalize(this.$t('repairSyncQueue.title')) + '?',
					text: this.$t('repairSyncQueue.text'),
					icon: 'info',
					buttons: [this.$t('no'), this.$t('yes')]
				}).then((response) => {
					if (response) {
						el.classList.add('running')
						this.$bridge.repairSyncQueue()
					}
				})
			},
			async uploadDb () {
				try {
					let response = await this.$swal({
						title: this.$options.filters.capitalize(this.$t('uploadDb.title')) + '?',
						text: this.$t('uploadDb.text'),
						icon: 'info',
						buttons: [this.$t('no'), this.$t('yes')]
					})

					if (response) {
						const filename = `Merchant:${this.merchant.id}-deviceId:${this.deviceId}-locationId:${this.locationId}-date:${new Date().valueOf()}.realm`

						response = await this.$store.dispatch('getS3Url', {
							filename,
							type: 'realm'
						})
						await this.$bridge.uploadDB(filename, response.data.url)
					}
				} catch (err) {
					console.error(err)
				}
			},
			async forceSync (model, $event) {
				const date = new Date()
				const el = $event.currentTarget
				const options = await this.getSyncOptions(model)

				const cb = () => {
					this.$store.commit('setProgress', { value: 100 })
					setTimeout(() => {
						el.classList.remove('running')
						this.$store.commit('resetProgress')
						this.$emit('update:syncDetails', $event)
					}, 1000)
				}

				if (options) {
					if (options.model === 'merchant-reservation' && this.appVersionNumber >= 4134 && this.merchant.subscription.products.restaurant_reservation) {
						el.classList.add('running')
						this.syncV2(options).then(cb).catch(cb)
					} else {
						el.classList.add('running')
						this.sync(options).then(cb).catch(cb)
					}
				} else {
					this.$swal({
						title: this.$t('areYouSure'),
						text: this.selectedModel.length ? this.$t('forceSyncOptionWarning') : this.$t('forceSyncWarning'),
						icon: 'warning',
						buttons: [this.$t('no'), this.$t('yes')],
						dangerMode: true
					}).then((response) => {
						if (response) {
							el.classList.add('running')
							this.syncAll({ force: true, syncOption: this.selectedModel })
								.then(() => {
									cb()
									this.$bridge.setLocalStorage('lastForceSyncDate', date)
								}).catch(cb)
						}
					})
				}
			}
		}
	}
